module.exports = __webpack_public_path__ + "static/media/Grupo1.68f38505.svg";